import { render, staticRenderFns } from "./Dogs.vue?vue&type=template&id=12db5f9a&"
import script from "./Dogs.vue?vue&type=script&lang=js&"
export * from "./Dogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports